import PromisePolyfill from 'promise-polyfill';
import _ from 'lodash';

if (!Array.prototype.find) {
  // FIXME: this is a bandaid as it is not 100% compliant with Array.prototype.find
  // Instead what we ought to be doing here is replacing all references to
  // Array.find() with _.find()
  Array.prototype.find = (predicate: any) => _.find(this, predicate);
}

if (!(window as any).Promise) {
  (window as any).Promise = PromisePolyfill;
}

// some browsers still don't define console at this day and age...
if (!(window as any).console) {
  const stubs = [
    'assert',
    'clear',
    'count',
    'debug',
    'dir',
    'dirxml',
    'error',
    'exception',
    'group',
    'groupCollapsed',
    'groupEnd',
    'info',
    'log',
    'profile',
    'profileEnd',
    'table',
    'time',
    'timeEnd',
    'timeStamp',
    'trace',
    'warn'
  ];

  const noop = () => {
    /* noop */
  };

  (window as any).console = stubs.reduce((acc: any, name: string) => {
    acc[name] = noop;
    return acc;
  }, {});
}
